import { FabricObject, util } from 'fabric'

// ActiveSelection temporarily puts each artwork's coordinates/scales in the
// selection's plane. Flatten a geometry-only copy with Fabric's own transform
// logic, just as deselection would, without changing selection or live artwork.
export function placedObjectGeometry(object) {
  if (!object?.group || typeof object.calcTransformMatrix !== 'function') return object

  const geometry = new FabricObject({
    width: object.width,
    height: object.height,
    originX: object.originX,
    originY: object.originY,
    strokeWidth: object.strokeWidth,
    strokeUniform: object.strokeUniform,
  })
  util.applyTransformToObject(geometry, object.calcTransformMatrix())
  return geometry
}
